<template>
	<div class="rb-player-button" :class="{ disabled }">
		<slot />
	</div>
</template>

<script>
	export default {
		name: 'RbPlayerButton',
		props: {
			disabled: {
				type: Boolean,
				default: false
			}
		}
	}
</script>

<style lang="scss" scoped>
	$ui-size: 2.4rem;

	.rb-player-button {
		display: inline-block;
		height: $ui-size * 1.5;
		line-height: $ui-size * 1.5;

		font-size: $ui-size * .7;

		padding: 0 $ui-size * .3;

		flex-shrink: 0;

		color: $highlight;
		text-shadow: 0 0 5px;
		white-space: nowrap;

		opacity: 1;
		cursor: pointer;
		position: relative;

		transition: all .2s;

		&.disabled {
			opacity: .5;
			cursor: default;
		}

		/deep/ .rb-icon {
			filter: drop-shadow(0 0 5px rgba(0, 0, 0, .5));
			transition: filter 0.5s ease 0s;
		}

		&:hover, &:focus {
			color: white;

			/deep/ .rb-icon {
				filter: drop-shadow(0 0 5px currentcolor);
			}
		}
	}
</style>
